const defaultConfig = {
  logo: '/img/logo.svg',
  background: '/img/login/bg-login.jpg',
  sysBrand: 'HAIJUN 海竣',
  sysTitle: '中小企业管理系统(SaaS)',
  sysSubTitle: '让中小企业管理变得更轻松！'
}

export { defaultConfig }
